import { motion } from "framer-motion";
import { Sparkles, RotateCcw } from "lucide-react";
import AIGiftCard from "./AIGiftCard";

export default function AIResultsSection({
  gifts,
  recipientName,
  onSave,
  onReset,
}) {
  if (!gifts || gifts.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="aiResultsSection"
    >
      <div className="aiResultsHeader">
        <div className="aiResultsTitleWrap">
          <div className="aiResultsIcon">
            <Sparkles size={20} />
          </div>

          <div>
            <h2>Handpicked for {recipientName || "Them"}</h2>
            <p>AI-curated gifts based on everything you shared</p>
          </div>
        </div>

        <button type="button" className="aiResultsResetBtn" onClick={onReset}>
          <RotateCcw size={16} />
          Start Over
        </button>
      </div>

      <div className="aiResultsGrid">
        {gifts.map((gift, index) => (
          <AIGiftCard
            key={`${gift.title}-${index}`}
            gift={gift}
            index={index}
            onSave={onSave}
          />
        ))}
      </div>
    </motion.div>
  );
}